export const timeUtils = {
  formatDateWithTime(value: string | number | Date | null | undefined, fallback = '-'): string {
    if (!value) return fallback

    const date = new Date(value)
    if (isNaN(date.getTime())) return fallback
    const datePart = new Intl.DateTimeFormat('pt-BR').format(date)

    const timePart = new Intl.DateTimeFormat('pt-BR', {
      hour: '2-digit',
      minute: '2-digit',
    }).format(date)

    return `${datePart} às ${timePart}`
  },

  formatDate(value: string | number | Date | null | undefined, fallback = '-'): string {
    if (!value) return fallback
    const date = new Date(value)
    if (isNaN(date.getTime())) return fallback

    return new Intl.DateTimeFormat('pt-BR').format(date)
  },

  formatTime(value: string | number | Date | null | undefined, fallback = '-'): string {
    if (!value) return fallback

    const date = new Date(value)

    if (isNaN(date.getTime())) return fallback

    return new Intl.DateTimeFormat('pt-BR', {
      hour: '2-digit',
      minute: '2-digit',
    }).format(date)
  },

  calculateEndTimeFromMinutes(
    startTime: string | Date | null | undefined,
    durationMinutes: number | null | undefined
  ): Date | null {
    if (!startTime || durationMinutes == null) return null

    const start = startTime instanceof Date ? startTime : new Date(startTime)
    if (isNaN(start.getTime())) return null

    const durationMs = durationMinutes * 60 * 1000
    return new Date(start.getTime() + durationMs)
  },

  formatMinutesToTime(minutes: number | null | undefined): string {
    if (minutes == null || isNaN(minutes) || minutes <= 0) return ''

    const totalSeconds = Math.round(minutes * 60)
    const hrs = Math.floor(totalSeconds / 3600)
    const mins = Math.floor((totalSeconds % 3600) / 60)
    const secs = totalSeconds % 60

    const parts: string[] = []
    if (hrs > 0) parts.push(`${hrs}h`)
    if (mins > 0) parts.push(`${mins}min`)
    if (secs > 0) parts.push(`${secs}s`)

    return parts.join(' ') || '0min'
  },

  calculateDuration(
    startTime: string | Date | null | undefined,
    endTime: string | Date | null | undefined,
    fallback = '--'
  ): string {
    if (!startTime || !endTime) return fallback

    const start = new Date(startTime).getTime()
    const end = new Date(endTime).getTime()
    const elapsed = end - start

    if (isNaN(elapsed) || elapsed < 0) return fallback

    const hours = Math.floor(elapsed / 1000 / 60 / 60)
    const minutes = Math.floor((elapsed / 1000 / 60) % 60)
    const seconds = Math.floor((elapsed / 1000) % 60)

    if (hours > 0) {
      return `${hours}h ${minutes}min`
    }

    if (minutes === 0) {
      return `${seconds}s`
    }

    return `${minutes}min ${seconds}s`
  },
}
